module.exports = __webpack_public_path__ + "static/media/amazonws.da31ba36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/amazonws.jpg
// module id = 270
// module chunks = 0